import React, { FC, useEffect, useState } from 'react'
import { Guid } from '../../../api/baseApi'
import { PlayNowList, PlayNowListStatus } from '../../../api/playNowListApi'
import { Button } from '../Button'
import DescriptionList from '../descriptionList/descriptionList'
import { FormRow, FormSelect } from '../formRow/FormRow'
import GlobalSpinner from '../globalsSpinner/GlobalSpinner'
import SvgSelector from '../svgSelector/SvgSelector'
import './PlayNowFullscreen.css'
import Select, { SingleValue } from "react-select";

interface IPlayNowListFullscreen {
    playNowLists: PlayNowList[],
    isLoading: boolean,
    activatePlayNow: (id:Guid) => void,
    inactivatePlayNow: (id:Guid) => void,
    exitFullscreen: () => void
}

type SelectedPlayList = {
    id: Guid,
    key : number
}


const PlayNowFullscreen:FC<IPlayNowListFullscreen> = ({playNowLists, isLoading, activatePlayNow, inactivatePlayNow, exitFullscreen}) => {
    let [selectedPlayLists, setSelectedPlayLists] = useState<SelectedPlayList[]>([]);
    let [currentIndex, setCurrentIndex] = useState<number>(0);
    let [isDisabledSelectFullscreenMode, setIsDisabledSelectFullscreenMode] = useState(false);

    let findById = (id: Guid) => playNowLists.find(it => it.id == id); 
    
    useEffect(()=>{
        // let actualList = playNowLists.filter(it => selectedPlayLists.some(it2 => it2.id === it.id));
        // let actualOpt = playNowLists.filter(it => selectedPlayLists.some(it2 => it2.id != it.id));

        // if(curOptions.length === 0){
        //     setCurOptions(playNowLists);
        //     if(selectedPlayLists.length === playNowLists.length){
        //         setCurOptions([]);
        //     }
        // } else {
        //     setCurOptions(actualOpt)
        // }
        
        // setSelectedPlayLists(actualList);
    },[playNowLists])

    useEffect(()=>{
        if(currentIndex >= 9 ) {
            setIsDisabledSelectFullscreenMode(true)
        } else {setIsDisabledSelectFullscreenMode(false)}
    },[currentIndex])

    const renderStatusPlayNow = (status: PlayNowListStatus) => {
        switch(status){
            case PlayNowListStatus.Active : return <span className="status-active">Active</span>
            case PlayNowListStatus.Inactive : return <span className="status-paused">Inactive</span>
        }
    }

    const renderFullscreenPlayNowRow = (selectePlayList: SelectedPlayList) => {
        let item = findById(selectePlayList.id);
        if(item){
            return <div className={`playnow__elem ${item.status === PlayNowListStatus.Active ? 'active' : ''}`} key={item.id}>
            <div className="playnow__elem-control">
                <span onClick={()=> onPlayNowListRemove(selectePlayList.id)}><SvgSelector title='cross' /></span>
                <p>{selectePlayList.key}</p>
            </div>
            <DescriptionList title='Name' value={item.name}/>
            <DescriptionList title='Networks' value={<>{item.channels.map(it => <p>{it.name}</p>)}</>}/>
            <DescriptionList title='Status' value={renderStatusPlayNow(item.status)}/>
        </div>
        }
      
    }

    const handleKeyboardClick = function(e:any){
        let key = +e.key;
        if(typeof key === "number"){
            if(key > 0 && key < 10){
                let playListItem = selectedPlayLists.find(it => it.key == key)                
                if(playListItem){
                    let playList = findById(playListItem.id);
                    if(playList){
                        if(playList.status === PlayNowListStatus.Active){
                            inactivatePlayNow(playList.id)
                        } 
                        if(playList.status === PlayNowListStatus.Inactive){
                            activatePlayNow(playList.id)
                        } 
                    }                  
                }
            }
        }
    }

    let playNowSelectOptions = () => {
        let notSelectedPlayLists = playNowLists.filter(it => selectedPlayLists.findIndex(spl => spl.id === it.id) === -1)
        let options = notSelectedPlayLists.map(it => {
            return {label: it.name, value: it.id}
        });

        return options;
    }

    type Option<T> = { value: T, label: string} 

    const onPlayNowListSelect = (item: SingleValue<Option<Guid>>) => {
        if(!!item){
            var key = currentIndex+1;
            let playListToAdd : SelectedPlayList = { key: key, id: item.value};
            setCurrentIndex(currentIndex+1);
            setSelectedPlayLists([...selectedPlayLists, playListToAdd]);
        }
    }

    const onPlayNowListRemove = (id:Guid) => {
        let removedItem = selectedPlayLists.find(it => it.id === id);
        if(!!removedItem){
            let removedKey = removedItem.key;
            let withoutRemovedItem = selectedPlayLists.filter(it => it.id !== id);
            withoutRemovedItem.forEach(element => {
                if(element.key > removedKey) element.key = element.key-1;
            });
            setSelectedPlayLists(withoutRemovedItem);
            setCurrentIndex(currentIndex-1);
        }
        
    }

    const onExitFullscreen = () => {
        // setSelectedPlayLists([]);
        // setCurOptions(playNowLists);
        exitFullscreen();
    }

    return (
        <div className="fullscreen-container" tabIndex={0} onKeyDown={(e)=>handleKeyboardClick(e)}>
            <div className="d-flex justify-content-between align-items-center mb-20 pt-50">
                <div className="select-container" >
                    <Select 
                        autoFocus={false}
                        isDisabled={isDisabledSelectFullscreenMode}
                        options={playNowSelectOptions()}
                        classNamePrefix={`select`}
                        onChange={onPlayNowListSelect} 
                        onMenuClose={()=>{}}
                        controlShouldRenderValue={false}
                        onKeyDown={e => e.stopPropagation()}
                    />
                </div>
                <Button color="green"  label="Exit Fullscreen Mode" onClick={onExitFullscreen} />
            </div>
            <div className="playnow__table">
                {selectedPlayLists.map(it => renderFullscreenPlayNowRow(it))}
            </div>
            <GlobalSpinner isShow={isLoading} />
        </div>
    )
}

export default PlayNowFullscreen
